// extracted by mini-css-extract-plugin
export var banner = "Banner-module--banner--3X8Us";
export var success = "Banner-module--success--ilH1f";
export var error = "Banner-module--error--3Oao4";